import { CVDataType } from "../../types/dataTypes";

export function buildCvPayload(cvData: CVDataType[], deletedCvIDs: number[]) {
  const cvDetails = cvData.map((cvDetail) => {
    const { viewCV, isNew, cvDataType, ...metadata } = cvDetail;
    return isNew ? { ...metadata, cvDataType } : metadata;
  });

  return { cvDetails, deletedCvIDs };
}